const minutesInSeconds = (minutes) => {
  return minutes * 60;
};

export const EXPIRATION_NOTIFICATION_VALUES = [
  { name: "5 segundos antes", value: 5 },
  { name: "10 segundos antes", value: 10 },
  { name: "15 segundos antes", value: 15 },
  { name: "20 segundos antes", value: 20 },
  { name: "30 segundos antes", value: 30 },
  { name: "40 segundos antes", value: 40 },
  { name: "45 segundos antes", value: 45 },
  { name: "50 segundos antes", value: 50 },
  { name: "1 minuto antes", value: minutesInSeconds(1) },
  { name: "2 minutos antes", value: minutesInSeconds(2) },
  { name: "3 minutos antes", value: minutesInSeconds(3) },
  { name: "4 minutos antes", value: minutesInSeconds(4) },
  { name: "5 minutos antes", value: minutesInSeconds(5) },
  { name: "6 minutos antes", value: minutesInSeconds(6) },
  { name: "7 minutos antes", value: minutesInSeconds(7) },
  { name: "8 minutos antes", value: minutesInSeconds(8) },
  { name: "9 minutos antes", value: minutesInSeconds(9) },
  { name: "10 minutos antes", value: minutesInSeconds(10) },
  { name: "15 minutos antes", value: minutesInSeconds(15) },
  { name: "20 minutos antes", value: minutesInSeconds(20) },
  { name: "30 minutos antes", value: minutesInSeconds(30) },
];
